// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ljlcuPnbK6qQqLeJuP1Q{max-width:466px;border-left:4px solid var(--theme-primary);margin-top:var(--spacing-sm)}`, "",{"version":3,"sources":["webpack://./src/components/ai-panel/ai-cards/ai-support-card/ai-support-card.scss"],"names":[],"mappings":"AAAA,sBACI,eAAA,CACA,0CAAA,CACA,4BAAA","sourcesContent":[".cardBorder {\n    max-width: 466px;\n    border-left: 4px solid var(--theme-primary);\n    margin-top: var(--spacing-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBorder": `ljlcuPnbK6qQqLeJuP1Q`
};
export default ___CSS_LOADER_EXPORT___;
